import { render } from "./Clientes.vue?vue&type=template&id=791a6903&scoped=true"
import script from "./Clientes.vue?vue&type=script&lang=js"
export * from "./Clientes.vue?vue&type=script&lang=js"

import "./Clientes.vue?vue&type=style&index=0&id=791a6903&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-791a6903"

export default script